import script from "./FavouriteAside.vue?vue&type=script&lang=ts&setup=true"
export * from "./FavouriteAside.vue?vue&type=script&lang=ts&setup=true"

import "./FavouriteAside.vue?vue&type=style&index=0&id=e862a722&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e862a722"]])

export default __exports__